import React, { useEffect, useMemo } from "react";
import { useLedgers } from "@api/ledger.api";
import { getAccountingBasisLabel } from "@common/helpers/accountingBasis";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { Entity } from "@common/types/entity";
import { LedgerBasisSelect } from "@components/ledger/LedgerBasisSelect";

interface Props {
    selectedEntity?: Entity;
    selectedLedgerId?: string;
    onChange: (ledgerId: string) => void;
    className?: string;
}

export const SchedulesReportLedgerSelect: React.FC<Props> = ({
    selectedEntity,
    selectedLedgerId,
    onChange,
    className,
}) => {
    const { data: ledgers } = useLedgers(selectedEntity?.id);

    const options = useMemo(
        () =>
            (ledgers ?? [])
                .filter(
                    (ledger) => ledger.basis === AccountingLedgerBasis.accruals,
                )
                .map((ledger) => ({
                    value: ledger.id,
                    label: ledger.name || getAccountingBasisLabel(ledger.basis),
                })),
        [ledgers],
    );

    const isSelectedLedgerAccrual = options.some(
        (option) => option.value === selectedLedgerId,
    );

    useEffect(() => {
        if (!isSelectedLedgerAccrual && options[0]) {
            onChange(options[0].value);
        }
    }, [isSelectedLedgerAccrual, options, onChange]);

    if (options.length === 0) {
        return null;
    }

    return (
        <LedgerBasisSelect
            options={options}
            value={
                isSelectedLedgerAccrual ? selectedLedgerId : options[0].value
            }
            onChange={onChange}
            className={className}
            shouldShowSingleOption
        />
    );
};
